import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fujiafeiguize",
  "use": "icon-fujiafeiguize-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-fujiafeiguize\"><path d=\"M14.377 6.304c.402.43.623.917.623 1.435 0 .566-.26 1.083-.72 1.535.463.455.72.976.72 1.535 0 1.972-3.164 3.369-7 3.369s-7-1.398-7-3.37c0-.559.257-1.08.72-1.534C1.26 8.822 1 8.305 1 7.739c0-.518.221-1.004.623-1.435C1.223 5.878 1 5.394 1 4.87 1 2.897 4.164 1.5 8 1.5s7 1.397 7 3.37c0 .524-.223 1.007-.623 1.434zm-.78.632C12.315 7.747 10.275 8.239 8 8.239c-2.275 0-4.314-.492-5.597-1.303-.272.272-.403.543-.403.803 0 1.197 2.656 2.37 6 2.37s6-1.173 6-2.37c0-.26-.131-.53-.403-.803zm.013 2.861c-1.281.817-3.327 1.311-5.61 1.311-2.2 0-4.18-.459-5.467-1.223-.36.312-.533.625-.533.923 0 1.197 2.656 2.37 6 2.37s6-1.173 6-2.37c0-.288-.161-.59-.497-.892l.107-.119zM8 7.239c3.344 0 6-1.173 6-2.37C14 3.674 11.344 2.5 8 2.5S2 3.672 2 4.87c0 1.196 2.656 2.369 6 2.369z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fujiafeiguize.svg
// module id = 460
// module chunks = 4